import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import PhoneInput from 'react-phone-number-input';

import 'react-phone-number-input/style.css';
import './../fields.css';

class PhoneField extends React.Component {
    render() {
        const {
            input,
            placeholder,
            disabled,
            hideErrors,
            intl,
            id,
            country,
            meta: { touched, error, warning }
        } = this.props;
        let placeholderContent = typeof placeholder === 'string' ? placeholder : intl.formatMessage(placeholder);

        let phoneCountry = country || (input.value ? undefined : 'US');
        if (phoneCountry === 'UK') {
            phoneCountry = 'GB';
        }

        if (disabled) {
            return (
                <div className="pone-field">
                    <div className="field-placeholder">{placeholderContent}</div>
                    <span id={id ? id : ''} className="disabled-input">
                        {input.value}
                    </span>
                    <span className="validation-message" />
                </div>
            );
        }

        return (
            <div className="phone-field">
                <div className="wrapper">
                    {(input.value || input.value === 0) && <div className="field-placeholder">{placeholderContent}</div>}
                    <PhoneInput country={phoneCountry} placeholder={placeholderContent} {...(id ? { id } : {})} {...input} />
                </div>
                <span className="validation-message">{touched && !hideErrors && (error || warning)}</span>
            </div>
        );
    }
}

PhoneField.defaultProps = {
    placeholder: '',
    type: '',
    meta: {},
    input: {}
};

PhoneField.propTypes = {
    placeholder: PropTypes.any,
    type: PropTypes.string,
    meta: PropTypes.object,
    input: PropTypes.object
};

export default injectIntl(PhoneField);



// WEBPACK FOOTER //
// ./src/components/fields/phone/index.js